import {
  Dashboard,
  useState,
  useEffect,
  Pagination,
  exportFromJSON,
  moment,
  DatePicker,
} from "./import";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import {
  DownOutlined,
  ReloadOutlined,
  RightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import ReactLoading from "react-loading";
import useAxios from "../../../hooks/useAxios";
import { Card, Input, message, Table, Tooltip, Typography } from "antd";
import { changeDateAndTimeFormat } from "../../../utils/commonFunctions";
import ShowRecruiters from "../components/ShowRecruiters";
import { checkPermission } from "../../../utils/checkPermission";
import useRole from "../../../hooks/useRole";
const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

const exportType = "csv";

const TAB_CARDS = [
  {
    key: "totalVoiceTin",
    label: "Total Voice TIN",
    value: 0,
    child: [
      {
        key: "used",
        label: "Used",
        value: 0,
      },

      {
        key: "unUsed",
        label: "Unused",
        value: 0,
      },
    ],
  },
  {
    key: "totalWrittenTin",
    label: "Total Written TIN",
    value: 0,
    child: [
      {
        key: "used",
        label: "Used",
        value: 0,
      },

      {
        key: "unUsed",
        label: "Unused",
        value: 0,
      },
    ],
  },
  {
    key: "reattemptPercent",
    label: "Reattempt %",
    value: 0,
    child: [
      {
        key: "voice",
        label: "Voice",
        value: 0,
      },
      {
        key: "written",
        label: "Written",
        value: 0,
      },
    ],
  },
  {
    key: "approvedRequests",
    label: "Approved Requests",
    value: 0,
    child: [
      {
        key: "voice",
        label: "Voice",
        value: 0,
      },
      {
        key: "written",
        label: "Written",
        value: 0,
      },
    ],
  },
  {
    key: "pendingApproval",
    label: "Pending Approval",
    value: 0,
    child: [
      {
        key: "voice",
        label: "Voice",
        value: 0,
      },

      {
        key: "written",
        label: "Written",
        value: 0,
      },
    ],
  },
];

const TinUsageReport = () => {
  const api = useAxios();
  const [search, setSearch] = useState("");
  const [userReport, setUserReport] = useState([]);
  const [modal, setModal] = useState(false);
  const [tinReport, setTinReport] = useState([]);
  const [current, setCurrent] = useState(1);
  const [userId, setUserId] = useState("");
  const [documentStatus, setDocumentStatus] = useState("");
  const [defaultDate, setDefaultDate] = useState([]);
  const [startDate, setStartDate] = useState();
  const [load, setLoad] = useState(false);
  const [tabCards, setTabCards] = useState(TAB_CARDS);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [canExportTin, setCanExportTin] = useState(false);
  const [canUploadTin, setCanUploadTin] = useState(false);
  const [canSyncTin, setCanSyncTin] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const exportAllowed = await checkPermission(
        userRole,
        "tin_usage_report_module",
        "export"
      );
      const uploadAllowed = await checkPermission(
        userRole,
        "tin_usage_report_module",
        "upload"
      );
      const syncAllowed = await checkPermission(
        userRole,
        "tin_usage_report_module",
        "sync"
      );
      setCanExportTin(exportAllowed);
      setCanUploadTin(uploadAllowed);
      setCanSyncTin(syncAllowed);
    } catch (err) {
      console.error("Error checking TIN permissions:", err);
    }
  };

  useEffect(() => {
    checkPermissions();
  }, [userRole]);
  const columns = [
    {
      title: "PROCESS",
      dataIndex: "process",
      key: "process",
    },
    {
      title: "TOTAL TIN USED",
      dataIndex: "tinUsed",
      key: "tinUsed",
      render: (value, row) => {
        return <span>{value}</span>;
      },
    },
    {
      title: "ACTION",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      render: (action, row) => {
        const { processId } = action;
        return (
          <div className="w-full flex gap-1">
            {canUploadTin && (
            <button
              size="sm"
              type="primary"
              className="btn-sm btn-primary"
              onClick={(e) => {
                e.stopPropagation();
                onClickView(processId)
              }}
            >
              View <i class="fa fa-edit"></i>
            </button>
            )}
          </div>
        );
      },
    },
  ];

  const toggle = () => setModal(!modal);

  function disableFutureDates(current) {
    const maxDate = startDate
      ? moment(startDate).add(6, "month")
      : moment().endOf("day");

    return current && (current > moment().endOf("day") || current > maxDate);
  }

  const handleCalendarChange = (dates) => {
    if (dates && dates[0]) {
      setStartDate(dates[0]);
    } else {
      setStartDate(null);
    }
  };

  const handleDate = (value, dateString) => {
    if (value === null) {
      setDefaultDate([
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
      ]);
    } else {
      setDefaultDate(dateString);
    }
  };

  const onChange = async (page) => {
    try {
      setLoad(true);
      setCurrent(page);
      await getUserTinList(userId, page);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  const getPercent = (totalValue, value) => {
    if (!totalValue) return 0;
    return ((value / totalValue) * 100).toFixed(2);
  };

  const allCounts = async () => {
    try {
      const { data } = await api.get(`/manageTin/Reports/Card`, {
        tokenType: "user",
      });

      const { dashboardCounts, pendingApproval } = data;

      const {
        unusedVoice,
        usedVoice,
        unusedWritten,
        usedWritten,
        totalWritten,
        totalVoice,

        reattemptWrittenCandidate,
        reattemptVoiceCandidate,

        reattemptvoiceAllCandidate,
        reattemptWrittenAllCandidate,
      } = dashboardCounts?.[0] || {};

      const {
        totalWritten: totalPendingWritten,
        totalVoice: totalPendingVoice,
      } = pendingApproval?.[0] || {};

      const voicePercent = getPercent(
        reattemptvoiceAllCandidate || 0,
        reattemptVoiceCandidate || 0,
      );
      const writtenPercent = getPercent(
        reattemptWrittenAllCandidate || 0,
        reattemptWrittenCandidate || 0,
      );
      const totalPercent = getPercent(
        (reattemptvoiceAllCandidate || 0) + (reattemptWrittenAllCandidate || 0),
        (reattemptWrittenCandidate || 0) + (reattemptVoiceCandidate || 0),
      );

      const TAB_CARDS = [
        {
          key: "totalVoiceTin",
          label: "Total Voice TIN",
          value: totalVoice || 0,
          child: [
            { key: "used", label: "Used", value: usedVoice || 0 },
            { key: "unUsed", label: "Unused", value: unusedVoice || 0 },
          ],
          isHover: false,
        },
        {
          key: "totalWrittenTin",
          label: "Total Written TIN",
          value: totalWritten || 0,
          child: [
            { key: "used", label: "Used", value: usedWritten || 0 },
            { key: "unUsed", label: "Unused", value: unusedWritten || 0 },
          ],
          isHover: false,
        },
        {
          key: "reattemptPercent",
          label: "Reattempt %",
          value: `${totalPercent}%`,
          child: [
            { key: "voice", label: "Voice", value: `${voicePercent}%` },
            {
              key: "written",
              label: "Written",
              value: `${writtenPercent}%`,
            },
          ],
          isHover: true,
        },
        {
          key: "pendingApproval",
          label: "Pending Approval",
          value: (totalPendingVoice || 0) + (totalPendingWritten || 0),
          child: [
            { key: "voice", label: "Voice", value: totalPendingVoice || 0 },
            {
              key: "written",
              label: "Written",
              value: totalPendingWritten || 0,
            },
          ],
          isHover: false,
        },
      ];

      setTabCards(TAB_CARDS);
    } catch (err) {
      console.error(err);
    }
  };

  const getTinUsageReport = async () => {
    try {
      const { data } = await api.get(`/manageTin/Reports/TinUses`, {
        tokenType: "user",
      });

      const _rows = [];

      const grouped = Object.values(
        data.reduce((acc, item) => {
          const key = item.process_name;

          if (!acc[key]) {
            acc[key] = {
              processId: item.processId,
              process_name: item.process_name,
              total_tin_used: 0,
              users: [],
            };
          }

          acc[key].total_tin_used += item.total_tin_used;
          acc[key].users.push(item);

          return acc;
        }, {}),
      );

      for (let row of grouped) {
        _rows.push({
          key: `${row?.process_name}`,
          process: row?.process_name,
          tinUsed: row?.total_tin_used,
          processId: row?.processId,
          users: row.users,
          action: row,
        });
      }

      setUserReport(_rows);
    } catch (err) {
      console.log(err);
    }
  };

  const init = async () => {
    try {
      setLoad(true);
      await Promise.all([allCounts(), getTinUsageReport()]);
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    init();
  }, []);

  const getUserTinList = async (id, current = 1) => {
    try {
      const { data } = await api.get(
        `/manageTin/${id}?PageNo=${current}&PageSize=10`,
        {
          tokenType: "user",
        },
      );
      setTinReport(data);
    } catch (err) {
      console.log(err);
    }
  };

  const onClickView = async (id) => {
    try {
      setLoad(true);
      setUserId(id);
      await getUserTinList(id);
      toggle();
    } catch (err) {
      console.error(err);
    } finally {
      setLoad(false);
    }
  };

  async function onClickDownloadCSV() {
    const flattens = function (data) {
      var result = {};
      function sanitizeField(field) {
        return field.replace(/[^\w\s]/gi, "");
      }
      function recurse(cur, prop) {
        if (Object(cur) !== cur) {
          result[sanitizeField(prop)] = cur;
        } else if (Array.isArray(cur)) {
          for (var i = 0, l = cur.length; i < l; i++)
            recurse(cur[i], sanitizeField(prop) + "[" + i + "]");
          if (l == 0) result[sanitizeField(prop)] = [];
        } else {
          var isEmpty = true;
          for (var p in cur) {
            isEmpty = false;
            recurse(cur[p], sanitizeField(p));
          }
          if (isEmpty && prop) result[sanitizeField(prop)] = {};
        }
      }
      recurse(data, "");
      return result;
    };

    try {
      setLoad(true);
      const candidateData = await downloadCsv();
      let data = [];

      data =
        candidateData &&
        candidateData.map((el) => {
          return flattens(el);
        });
      let fileName = `Candidates_${moment(new Date()).format(
        "DD-MM-YYYY_HH:mm",
      )}`;
      if (data && data?.length > 0) {
        exportFromJSON({ data, fileName, exportType });
      } else {
        return message.error("No data fond.");
      }
      message.success("Report downloaded successfully.");
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoad(false);
    }
  }

  const downloadCsv = async () => {
    try {
      const { data } = await api.get(
        `manageTin/Reports/TinUsageAll?StartDate=${
          defaultDate?.[0]
            ? defaultDate[0]
            : moment(new Date()).format("YYYY-MM-DD")
        }&EndDate=${
          defaultDate?.[1]
            ? defaultDate[1]
            : moment(new Date()).format("YYYY-MM-DD")
        }`,
        { tokenType: "user" },
      );

      return data?.tinList;
    } catch (err) {
      console.error(err);
    }
  };

  const refreshNewTINs = async () => {
    try {
      setLoad(true);
      await api.get(`/processbasedversant/tincreation`, { tokenType: "user" });

      message.success("TIN refresh successfully.");
    } catch (err) {
      console.error(err);
      message.error("Something went wrong.");
    } finally {
      setLoad(false);
    }
  };

  // const downloadSingleUserReport = () => {
  //   setLoad(true);
  //   axios
  //     .get(
  //       `manageTin/Reports/TinUsage/${userId}?StartDate=${
  //         defaultDate[0]
  //           ? defaultDate[0]
  //           : moment(new Date()).format("YYYY-MM-DD")
  //       }&EndDate=${
  //         defaultDate[1]
  //           ? defaultDate[1]
  //           : moment(new Date()).format("YYYY-MM-DD")
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //         },
  //       },
  //     )
  //     .then((res) => {
  //       const tinFormat = res?.data?.tinList?.map((ele) => {
  //         return {
  //           interviewer_name: ele?.assignUserId?.name,
  //           interviewer_email: ele?.assignUserId?.email,
  //           candidate_name: ele?.candidateId?.name,
  //           candidate_email: ele?.candidateId?.email,
  //           mobile_no: ele?.candidateId?.mobileNo,
  //           tin: ele?.tinNo,
  //           TIN_status: ele.tinStatus ? "Active" : "inActive",
  //           reason: ele?.RequestReason,
  //           assign_date: ele?.assignDate
  //             ? changeDateAndTimeFormat(ele?.assignDate)
  //             : "",
  //           used_date: ele?.usedDate
  //             ? changeDateAndTimeFormat(ele?.usedDate)
  //             : "",
  //           trf: ele?.candidateId?.trf?.title,
  //           location: ele?.candidateId?.trf?.location,
  //           process: ele?.candidateId?.trf?.processName,
  //           createdAt: ele?.createdAt
  //             ? changeDateAndTimeFormat(ele?.createdAt)
  //             : "",
  //           updatedAt: ele?.updatedAt
  //             ? changeDateAndTimeFormat(ele?.updatedAt)
  //             : "",
  //         };
  //       });
  //       let fileName = `TIN_USAGE_REPORT(single-user)${moment(
  //         new Date(),
  //       ).format("DD-MM-YYYY_HH:mm")}`;

  //       let data = tinFormat;
  //       exportFromJSON({ data, fileName, exportType });
  //     })
  //     .finally((res) => {
  //       setLoad(false);
  //     });
  // };

  const isDownloadDisable = defaultDate.length !== 2;

  const filteredRows = userReport.filter((row) => {
    const _search = search?.toLowerCase();
    return row.process?.toLowerCase().includes(_search);
  });

  const cardContent = (item) => (
    <Card
      bordered
      style={{
        borderColor: documentStatus === item ? "#0B56AD" : "#7D7C7C",
        padding: "7px",
        height: "120px",
        borderRadius: "6px",
        cursor: "pointer",
        background: documentStatus === item ? "#EBF4FF" : "#fff",
      }}
      bodyStyle={{ padding: 8 }}
    >
      <div className="flex gap-1 items-center">
        <Text className="font-semibold text-[14px] text-center w-full uppercase text-gray-600">
          {item?.label}
        </Text>
      </div>

      <div className="text-[24px] font-bold w-full text-center">
        {item?.value}
      </div>

      <div className="flex justify-center gap-1">
        <span className="text-[11px] font-semibold px-2 py-[3px] border border-blue-200 bg-blue-50 rounded-md text-blue-700">
          {item?.child[0]?.label}: {item?.child[0]?.value}
        </span>

        <span className="text-[11px] font-semibold px-2 py-[3px] border border-green-200 bg-green-50 rounded-md text-green-700">
          {item?.child[1]?.label}: {item?.child[1]?.value}
        </span>
      </div>
    </Card>
  );

  console.log(tinReport, "=====================");

  return (
    <Dashboard title={"Tin Usage Report"}>
      {load && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="py-1 px-1 mb-4">
        <h4 className="text-[1.5rem] mb-0">TIN Usage</h4>
      </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fit, minmax(215px, 1fr))`,
          gap: "1rem",
        }}
        className="mb-4"
      >
        {tabCards?.map((item, index) => {
          return (
            <div
              style={{
                width: "100%",
              }}
              key={index}
            >
              {item?.isHover ? (
                <Tooltip
                  placement="top"
                  title={
                    "Percentage of candidates who reattempted the Versant test."
                  }
                >
                  {cardContent(item)}
                </Tooltip>
              ) : (
                cardContent(item)
              )}
            </div>
          );
        })}
      </div>
      <div className="flex justify-between p-3 border mb-2 bg-white cursor-pointer align-items-center">
        <div className="">
          <RangePicker
            format="YYYY-MM-DD"
            className="w-100"
            onChange={handleDate}
            disabledDate={disableFutureDates}
            onCalendarChange={handleCalendarChange}
            placeholder={["Start date", "End date"]}
          />
        </div>
        <div className="">
          {canExportTin && (
            <button
              disabled={isDownloadDisable}
              className={`btn btn-block ${isDownloadDisable ? "btn-secondary" : "btn-primary"}`}
              onClick={onClickDownloadCSV}
            >
              <i class="fa fa-download mr-2" aria-hidden="true"></i> Download
              Report
            </button>
          )}
        </div>
      </div>
      <div>
        <Card>
          <div className="flex flex-col gap-[1.5rem]">
            <div className="flex justify-between">
              <div className="flex-grow">
                <Input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    borderRadius: "8px",
                    width: "100%",
                    maxWidth: "350px",
                  }}
                  size="large"
                  placeholder="Search by process..."
                  prefix={<SearchOutlined />}
                />
              </div>
              {/* <button
                onClick={refreshNewTINs}
                data-testid="refresh-new-tin"
                className="btn btn-primary flex items-center gap-1"
              >
                <ReloadOutlined
                  style={{ fontSize: "1.1rem", fontWeight: 600 }}
                />
                <span className="flex items-center text-[16px] font-semibold">
                  Sync New TINs
                </span>
              </button> */}
            </div>
            <div>
              <Table
                columns={columns}
                dataSource={filteredRows}
                pagination={{
                  total: filteredRows?.length,
                  pageSizeOptions: ["5", "10", "30"],
                  showSizeChanger: true,
                }}
                expandable={{
                  expandedRowKeys,
                  expandedRowRender: (record) => {
                    return <ShowRecruiters record={record} />;
                  },
                  onExpand: (expanded, record) => {
                    setExpandedRowKeys(expanded ? [record.key] : []);
                  },
                  expandIcon: ({ expanded, onExpand, record }) => (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        onExpand(record, e);
                      }}
                      style={{
                        cursor: "pointer",
                        fontWeight: "bold",
                        fontSize: "14px",
                      }}
                    >
                      {expanded ? <DownOutlined /> : <RightOutlined />}
                    </span>
                  ),
                }}
                onRow={(record) => ({
                  onClick: () => {
                    const isExpanded = expandedRowKeys.includes(record.key);
                    setExpandedRowKeys(isExpanded ? [] : [record.key]);
                  },
                })}
                showSorterTooltip={false}
                scroll={{ x: true }}
                style={{ whiteSpace: "pre" }}
                exportFileName="details"
                size="small"
              />
            </div>
          </div>
        </Card>
      </div>

      <Modal size={"xl"} isOpen={modal} toggle={toggle}>
        <ModalBody>
          <div className="card-body row border mb-2 bg-white cursor-pointer table-responsive text-nowrap overflow-auto">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Interviewer Name</th>
                  <th>Interviewer Email</th>
                  <th>Candidate Name</th>
                  <th>Candidate Email</th>
                  <th>Mobile_No</th>
                  <th>TIN No</th>
                  <th>TIN TYPE</th>
                  <th>TIN Status</th>
                  <th>Reason</th>
                  <th>Assigned Date</th>
                  <th>Used Date</th>
                  <th>Created-At</th>
                  <th>TRF</th>
                  <th>Location</th>
                  <th>Process</th>
                </tr>
              </thead>
              <tbody>
                {tinReport?.tinList?.map((ele,index) => {
                  return (
                    <tr>
                      <td>{(current - 1) * 10 + index + 1}</td>
                      <td>{ele?.assignUserId?.name}</td>
                      <td>{ele?.assignUserId?.email}</td>

                      <td>{ele?.candidateId?.name}</td>

                      <td>{ele?.candidateId?.email}</td>
                      <td>{ele?.candidateId?.mobileNo}</td>
                      <td>{ele?.tinNo}</td>
                      <td>{ele?.tinType}</td>
                      <td>{ele.status}</td>
                      <td>{ele?.RequestReason}</td>
                      <td>
                        {ele?.assignDate
                          ? changeDateAndTimeFormat(ele?.assignDate)
                          : ""}
                      </td>
                      <td>
                        {ele?.usedDate
                          ? changeDateAndTimeFormat(ele?.usedDate)
                          : ""}
                      </td>
                      <td>
                        {ele?.createdAt
                          ? changeDateAndTimeFormat(ele?.createdAt)
                          : ""}
                      </td>
                      <td>
                        {" "}
                        {ele?.candidateId?.trf?.title}-
                        {ele?.candidateId?.trf?.department}-
                        {ele?.candidateId?.trf?.location}-
                        {ele?.candidateId?.trf?.processName}-
                        {ele?.candidateId?.trf?.tat &&
                          moment(ele?.candidateId?.trf?.tat)
                            .utc()
                            .format("YYYY-MM-DD")}{" "}
                      </td>
                      <td>{ele?.candidateId?.trf?.title}</td>
                      <td>{ele?.candidateId?.trf?.location}</td>
                      <td>{ele?.candidateId?.trf?.processName}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination
              current={current}
              onChange={onChange}
              total={tinReport?.tinCount}
            />
          </div>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </Dashboard>
  );
};

export default TinUsageReport;
